/**
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Shared authentication utilities.
 *
 * Extracted from the individual shell components so all shells use the same
 * logout logic (design doc Section 4.1: "fix in place and share").
 */

/**
 * Perform a logout by POSTing to the auth endpoint and redirecting to login.
 * Uses the Vite BASE_URL to construct correct paths behind a reverse proxy.
 */
export function performLogout(): void {
  const base = (import.meta.env?.BASE_URL || '/').replace(/\/$/, '');
  fetch(`${base}/auth/logout`, {
    method: 'POST',
    credentials: 'include',
  })
    .then(() => {
      window.location.href = `${base}/auth/login`;
    })
    .catch((error) => {
      console.error('Logout failed:', error);
    });
}
